import { ExternalLookupOptions } from '@/typings';
import {
  adaptExternalLookupAdditionalArgumentResponseToExternalLookupArgument,
  adaptExternalLookupTypeResponseToExternalLookupType,
} from '../../lookups';
import { FormFieldExternalLookupResponseDTO } from '@/api/base/DTOs';

export const adaptFormFieldExternalLookupResponseToExternalLookupOptions = (
  formFieldExternalLookupResponse: FormFieldExternalLookupResponseDTO,
): ExternalLookupOptions => {
  const additionalLookupArguments =
    formFieldExternalLookupResponse.additionalLookupArguments
      ? adaptExternalLookupAdditionalArgumentResponseToExternalLookupArgument(
          formFieldExternalLookupResponse.additionalLookupArguments,
        )
      : undefined;

  return {
    lookupType: adaptExternalLookupTypeResponseToExternalLookupType(
      formFieldExternalLookupResponse.lookupType,
    ),
    isTypeAheadLookup: formFieldExternalLookupResponse.isTypeAheadLookup,
    additionalLookupArguments,
  };
};
